module.exports = __webpack_public_path__ + "img/H4.2cef7c9c.png";